import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_HOMEPAGE_FAIL = "SHOP:DELETE_HOMEPAGE_FAIL";

export const deleteHomepageFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: DELETE_HOMEPAGE_FAIL as typeof DELETE_HOMEPAGE_FAIL,
  organization,
  id,
});

export type DeleteHomepageFailAction = ReturnType<
  typeof deleteHomepageFailAction
>;
